import React from 'react'
import { connect } from '@cerebral/react'
import { state, props, signal } from 'cerebral/tags'
import { css } from 'aphrodite'
import themes from './styles'
import { t } from '@billes/translator-client'

export default connect(
  {
    pill: state`${props`path`}`,
    togglePillClicked: signal`media.togglePillClicked`
  },
  ({ pill, path, type, togglePillClicked, editMode, theme = 'light' }) => {
    if (!pill || pill.hidden) return null
    const { value, label, pinned, selected, key } = pill

    const styles = themes[theme]
    return (
      <div
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          if (!pinned && editMode)
            togglePillClicked({ path, type, value: value || label })
        }}
        className={css(
          styles.pill,
          selected ? null : styles.deselected,
          editMode && !pinned ? styles.toggleable : null
        )}
      >
        <div className={css(styles.label)}>{key ? t(key) : label}</div>
        {!pinned && editMode ? (
          <div className={css(styles.toggle)}>{selected ? 'x' : '+'}</div>
        ) : null}
      </div>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/Common/PillContainer/Pill/pill.js